import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  pos: defineAsyncComponent(() => import("/app/layouts/pos.vue").then(m => m.default || m))
}